import { render, staticRenderFns } from "./PrintBill.vue?vue&type=template&id=36bd880a"
import script from "./PrintBill.vue?vue&type=script&lang=js"
export * from "./PrintBill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports